 <template>
   <table class="balance-input table table-bordered h-100">
     <!-- Todo: show cespitiForm -->
     <!-- Todo: show detailedCreditsForm -->

     <!-- Header -->
     <thead>
     <tr>
       <th scope="col" class="sticky-header position-sticky bg-primary text-white">Attivo</th>
       <th scope="col" class="sticky-header position-sticky bg-primary text-white">Passivo</th>
     </tr>
     </thead>
     <tbody>
     <tr class="body-row">
       <td>
         <StatementRow label="Immobilizzazioni materiali e Immateriali" v-model="value.immobilizzazioniMaterialiEImmateriali" />
       </td>
       <td>
         <StatementRow label="Capitale sociale" v-model="value.capitaleSociale" />
       </td>
     </tr>
     <tr class="body-row">
       <td>
         <StatementRow label="Immobilizzazioni finanziarie" v-model="value.immobilizzazioniFinanziarie" />
       </td>
       <td>
         <StatementRow label="Riserve di utili" v-model="value.utiliPerditePregresse" />
       </td>
     </tr>
     <tr class="body-row">
       <td class="total-cell">
         <StatementRow label="Totale immobilizzazioni" is-computed :value="totaleImmobilizzazioni" />
       </td>
       <td>
         <StatementRow label="Riserve non distribuibili" v-model="value.riserve" />
       </td>
     </tr>
     <tr class="body-row">
       <td>
         <StatementRow label="Scorte" v-model="value.scorte" />
       </td>
       <td>
         <StatementRow label="Risultato d'esercizio" v-model="value.risultatoDEsercizio" />
       </td>
     </tr>
     <tr class="body-row">
       <td>
         <StatementRow label="Crediti verso Clienti" v-model="value.creditiVsClienti" />
       </td>
       <td>
         <StatementRow label="Prestito soci" v-model="value.prestitoSoci" />
       </td>
     </tr>
     <tr class="body-row">
       <td>
         <StatementRow label="Crediti tributari per imposte" v-model="value.creditiTributariPerImposte" />
       </td>
       <td class="total-cell">
         <StatementRow label="Patrimonio netto" is-computed :value="patrimonioNetto" />
       </td>
     </tr>
     <tr class="body-row">
       <td>
         <StatementRow label="Credito d'imposta" v-model="value.creditoDImposta" />
       </td>
       <td>
         <StatementRow label="Fondo TFR" v-model="value.fondoTfr" />
       </td>
     </tr>
     <tr class="body-row">
       <td>
         <StatementRow label="Credito IVA" v-model="value.creditoIva" />
       </td>
       <td>
         <StatementRow label="Altri fondi" v-model="value.altriFondi" />
       </td>
     </tr>
     <tr class="body-row">
       <td>
         <StatementRow label="Altri Crediti" v-model="value.altriCrediti" />
       </td>
       <td>
         <StatementRow label="Finanziamenti a medio lungo termine" v-model="value.finanziamentiAMedioLungoTermine" />
       </td>
     </tr>
     <tr class="body-row">
       <td class="total-cell">
         <StatementRow label="Totale crediti" is-computed :value="totaleCrediti" />
       </td>
       <td class="total-cell">
         <StatementRow label="Passivita consolidate" is-computed :value="passivitaConsolidate" />
       </td>
     </tr>
     <tr class="body-row">
       <td>
         <StatementRow label="Disponibilità" v-model="value.disponibilita" />
       </td>
       <td>
         <StatementRow label="Banche" v-model="value.banche" />
       </td>
     </tr>
     <tr class="body-row">
       <td class="total-cell">
         <StatementRow label="Attivo circolante" is-computed :value="attivoCircolante" />
       </td>
       <td>
         <StatementRow label="Quote a breve termine di finanziamenti" v-model="value.quoteABreveTermineDiFinanziamenti" />
       </td>
     </tr>
     <tr class="body-row">
       <td>
         <StatementRow label="Ratei attivi" v-model="value.rateiAttivi" />
       </td>
       <td>
         <StatementRow label="Fornitori" v-model="value.fornitori" />
       </td>
     </tr>
     <tr class="body-row">
       <td></td>
       <td>
         <StatementRow label="Debito IVA" v-model="value.debitoIva" />
       </td>
     </tr>
     <tr class="body-row">
       <td></td>
       <td>
         <StatementRow label="Debiti tributari per imposte" v-model="value.debitiTributariPerImposte" />
       </td>
     </tr>
     <tr class="body-row">
       <td></td>
       <td>
         <StatementRow label="Debiti tributari per ritenute" v-model="value.debitiTributariPerRitenute" />
       </td>
     </tr>
     <tr class="body-row">
       <td></td>
       <td>
         <StatementRow label="Debiti verso Enti previdenziali" v-model="value.debitiVersoEntiPrevidenziali" />
       </td>
     </tr>
     <tr class="body-row">
       <td></td>
       <td>
         <StatementRow label="Altri debiti" v-model="value.altriDebiti" />
       </td>
     </tr>
     <tr class="body-row">
       <td></td>
       <td class="total-cell">
         <StatementRow label="Passività correnti" is-computed :value="passivitaCorrenti" />
       </td>
     </tr>
     <tr class="body-row">
       <td></td>
       <td>
         <StatementRow label="Ratei passivi" v-model="value.rateiPassivi" />
       </td>
     </tr>

     <tr>
       <td class="sticky-footer position-sticky">
         <div class="container">
           <div class="row">
             <div class="col-7 d-flex align-items-center">
               <strong>Totale attivo</strong>
             </div>
             <div class="col-5 text-right">
               {{ totaleAttivo }}
             </div>
           </div>
         </div>
       </td>
       <td class="sticky-footer position-sticky">
         <div class="container">
           <div class="row">
             <div class="col-8 pl-0 d-flex align-items-center">
               <strong>Totale passivo</strong>
             </div>
             <div class="col-4 text-right">
               {{ totalePassivo }}
             </div>
           </div>
         </div>
       </td>
     </tr>
     </tbody>
   </table>
</template>

<script>

export default {
  components: {
    StatementRow: () => import('./BalanceInputStatementRow.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    totaleImmobilizzazioni () {
      let totale = (this.value?.immobilizzazioniMaterialiEImmateriali || 0);
      totale += (this.value?.immobilizzazioniFinanziarie || 0);

      return Math.floor(totale);
    },
    totaleCrediti () {
      let totale = (this.value?.creditiVsClienti || 0);
      totale += (this.value?.creditiTributariPerImposte || 0);
      totale += (this.value?.creditoDImposta || 0);
      totale += (this.value?.creditoIva || 0);
      totale += (this.value?.altriCrediti || 0);

      return Math.floor(totale);
    },
    attivoCircolante () {
      let totale = this.totaleCrediti;
      totale += (this.value?.scorte || 0);
      totale += (this.value?.disponibilita || 0);

      return Math.floor(totale);
    },
    totaleAttivo () {
      let totale = this.totaleImmobilizzazioni;
      totale += this.attivoCircolante;
      totale += (this.value?.rateiAttivi || 0);

      return Math.floor(totale);
    },

    patrimonioNetto () {
      let totale = (this.value?.capitaleSociale || 0);
      totale += (this.value?.riserve || 0);
      totale += (this.value?.utiliPerditePregresse || 0);
      totale += (this.value?.risultatoDEsercizio || 0);
      totale += (this.value?.prestitoSoci || 0);

      return Math.floor(totale);
    },
    passivitaConsolidate () {
      let totale = (this.value?.fondoTfr || 0);
      totale += (this.value?.altriFondi || 0);
      totale += (this.value?.finanziamentiAMedioLungoTermine || 0);

      return Math.floor(totale);
    },
    passivitaCorrenti () {
      let totale = (this.value?.banche || 0);
      totale += (this.value?.quoteABreveTermineDiFinanziamenti || 0);
      totale += (this.value?.fornitori || 0);
      totale += (this.value?.debitoIva || 0);
      totale += (this.value?.debitiTributariPerImposte || 0);
      totale += (this.value?.debitiTributariPerRitenute || 0);
      totale += (this.value?.debitiVersoEntiPrevidenziali || 0);
      totale += (this.value?.altriDebiti || 0);

      return Math.floor(totale);
    },
    totalePassivo () {
      let totale = this.patrimonioNetto;
      totale += this.passivitaConsolidate;
      totale += this.passivitaCorrenti;
      totale += (this.value?.rateiPassivi || 0);

      return Math.floor(totale);
    },
  },
};

</script>

<style lang="scss">

.balance-input {
  .sticky-header,
  .sticky-footer {
    z-index: 9;
  }

  .sticky-header {
    top: -1px;
  }

  .sticky-footer {
    background-color: #CEE5F5;
    bottom: 0;
    padding: 12px 0;
  }

  td {
    width: 50%;
  }

  .body-row {
    td {
      padding: 4px 0;

      &.total-cell {
        background: rgba(0,0,0,.18);
        font-weight: bold;

        .container {
          min-height: 38px;
        }
      }
    }

    .statement-value {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

</style>
